import React from 'react';
import ReactDOM from 'react-dom/client';
//import reportWebVitals from './reportWebVitals';
import './index.css';
//import App from './App'; 
import './k';

import { createBrowserRouter, RouterProvider } from 'react-router-dom';
 

import Bank1 from './bank1'; 


const root = ReactDOM.createRoot(document.getElementById('root'));
 
try {
    root.render(<Bank1 />);
} catch (e) {
    console.error("Error rendering the app:", e);
    root.render(
        <div className="text-white grid justify-center items-center h-[80vh]">
            <p>Something went wrong while loading the application.</p>
        </div>
    );
}